import { IUser } from 'types/user';

/**
 * Keeps the display-name invariant in one place: blank while loading (so the fallback never
 * flashes on first paint), then the resolved name or unknownLabel.
 */
export const resolveUserDisplayName = (
    user: IUser | undefined,
    isLoading: boolean,
    unknownLabel = 'Unknown',
) => user?.name ?? (isLoading ? '' : unknownLabel);
